import {css} from "styled-components";

export const Colors = css`
  :root {
    --point-color-1: #7910E1;
    --point-color-2: #3D0871;
    --point-color-3: #C99FF3;
    --point-color-4: #9F3EFF;
    --point-color-5: #F8F3FD;
    --point-color-6: #25004A;
    --white: #ffffff;
    --black: #000000;
    --black-95: #111111;
    --black-90: #1a1a1a;
    --black-50: #808080;
    --black-40: #999999;
    --black-10: #e6e6e6;
    --black-6: #f0f0f0;
    --black-2: #fafafa;
  }
`